module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAArElEQVQ4jbWUTQ6CQAyFH2U8wnj/E4FGdy7wHirPFEtCCE47RJt01/dNp38NSQBIAEbzGhPzpxjkBqAHkCsgGtuZNoGkkDzzY1eSWbN0XGMuplGtzIJsEAZgm7FuQASyBnmw4kPR1N1so3Vw61fqzhLmNkEqB/C7/fNrPyn2WnDc0/4SJDyQEYi7Irq0pyBkC6baaWkTybttcQSyhClkUMZ82A4AXjsPWwvg8QafN0sPp+HLggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close_white.png
// module id = Q5z7
// module chunks = 1